module.exports = __webpack_public_path__ + "gn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gn.svg
// module id = 828
// module chunks = 0